module.exports = __webpack_public_path__ + "img/flightLogo.0735c2ec.png";